//* Libraries Imports
import moment from "moment";

function DadosPessoaisPanel({ inscricao, renderCampo, formatSexo }) {
  return (
    <div className="row">
      <div className="col-md-6">
        <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
          Dados Pessoais
        </h5>
        {renderCampo("Nome Completo", inscricao.nomeCompleto)}
        {renderCampo("CPF", inscricao.cpf)}
        {renderCampo("Sexo", formatSexo(inscricao.sexo))}
        {renderCampo("Data de Nascimento", inscricao.dataNascimento, {
          transform: (v) =>
            v && moment(v).isValid() ? moment(v).format("DD/MM/YYYY") : "-",
        })}
        {renderCampo("Nome da Mãe", inscricao.nomeCompletoMae)}
        {renderCampo("RG", inscricao.rg)}
        {renderCampo("Órgão Emissor", inscricao.orgaoEmissor)}
        {renderCampo("Data de Expedição do RG", inscricao.dataExpedicaoRg, {
          transform: (v) =>
            v && moment(v).isValid() ? moment(v).format("DD/MM/YYYY") : "-",
        })}
      </div>

      <div className="col-md-6">
        <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
          Endereço
        </h5>
        {renderCampo("CEP", inscricao.cep)}
        {renderCampo("Rua", inscricao.nomeRua)}
        {renderCampo("Número", inscricao.numero)}
        {renderCampo("Complemento", inscricao.complemento)}
        {renderCampo("Bairro", inscricao.bairro)}
        {renderCampo("Cidade", inscricao.cidade)}
        {renderCampo("Estado", inscricao.estado)}
      </div>
    </div>
  );
}

export default DadosPessoaisPanel;